import { SimpleUser } from 'src/models/classes';

// eslint-disable-next-line import/prefer-default-export
export function sortSimpleUserByDisplayNameComparer(a: SimpleUser, b: SimpleUser) {
  const nameA = a.displayName;
  const nameB = b.displayName;

  return nameA.localeCompare(nameB, undefined, { numeric: true });
}
